import { SystemDialog } from '@ciancio/shared';

export const ConfirmDialog = ({ count, onCancel, onConfirm }) => {
  return (
    <SystemDialog title="Confirm upload" confirmLabel="Upload images" onCancel={onCancel} onConfirm={onConfirm}>
      <div className="text-center">
        <div className="upload-confirm-icon mx-auto mb-3"><i className="bi bi-images" /></div>
        <div className="display-6 mb-2">{count}</div>
        <p className="mb-2 fw-semibold">Ready to upload {count} image{count === 1 ? '' : 's'}?</p>
        <p className="mb-0 text-muted">The image{count === 1 ? '' : 's'} will be attached to a new collection code.</p>
      </div>
    </SystemDialog>
  );
}
